module.exports = __webpack_public_path__ + "img/menuboard-cho-express.677545ca.png";